var React = require('react');

function DotInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"r":"5","cy":"6","cx":"6","fill":"#3CBF0A","fillRule":"evenodd"}));
}

DotInline.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = DotInline;

DotInline.default = DotInline;
